<template>
  <div id="noticeWrapper">
    <div class="noticeContent">
      <div class="header">
        <van-tabs
          v-model="form.newsType"
          color="#4EA27C"
          line-height="4px"
          line-width="20px"
        >
          <van-tab title="荣光勋章" name="1"></van-tab>
          <van-tab title="星光勋章" name="2"></van-tab>
          <van-tab title="流光勋章" name="3"></van-tab>
        </van-tabs>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">标题</div>
        </div>
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">勋章类型</div>
        </div>
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">获奖人(个人/部门)</div>
        </div>
        <el-input
          @focus="awardsInfo"
          v-model="form.awards"
          placeholder="请输入获奖人"
        ></el-input>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">正文</div>
        </div>
        <!-- 两个upload 区别富文本 上传类型，
              不区别上传类型，上传视频，
              选择图片，会下载图片，
              声明数据 :accept=''会有延迟，异步行为
        -->
        <el-upload
          style="display: none"
          class="avatar-uploader"
          action="/hrApi/file/uploadNew"
          :show-file-list="false"
          accept="image/*"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
        </el-upload>
        <el-upload
          style="display: none"
          class="avatar-uploader1"
          action="/hrApi/file/uploadNew"
          :show-file-list="false"
          accept="video/*"
          :on-success="uploadSuccess"
          :on-error="uploadError"
        >
        </el-upload>
        <quill-editor
          ref="myQuillEditor"
          v-model="form.text"
          :options="editorOption"
        ></quill-editor>
      </div>
      <div class="container_itemAdd">
        <el-upload
          class="upload-demo"
          :on-remove="handleRemove"
          :file-list="fileList"
          :limit="1"
          accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.xlsx,xls"
          :on-exceed="handleExceed"
          action="/hrApi/file/uploadNew"
          :on-success="onSuccessFile"
        >
          <div
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <div class="title">
              <div class="title_txt">添加附件</div>
            </div>
            <img
              class="uploadImg"
              src="@/assets/newsNotice/link.png"
              alt=""
              style="width: 22px; height: 22px; margin-left: 20px"
            />
          </div>
        </el-upload>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">添加封面</div>
        </div>
        <el-upload
          action="/hrApi/file/uploadNew"
          list-type="picture-card"
          :file-list="fileListCover"
          :limit="1"
          accept="image/*"
          :on-remove="onRemoveCover"
          :on-success="onSuccessCover"
          :on-exceed="handleExceedImg"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">添加原文链接</div>
        </div>
        <el-input v-model="form.link" placeholder="请输入原文链接"></el-input>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">摘要</div>
        </div>
        <el-input v-model="form.remark" placeholder="请输入摘要"></el-input>
      </div>
    </div>
    <div class="footerBtn">
      <van-button
        type="default"
        size="small"
        style="background-color: #f3f3f3"
        @click="cancel"
        >取消</van-button
      >
      <van-button
        type="default"
        size="small"
        @click="submit(1)"
        style="color: #fff; background-color: #ea875b"
        >暂存</van-button
      >
      <van-button
        type="info"
        size="small"
        style="background-color: #4ea27c"
        @click="submit(2)"
        >确认</van-button
      >
    </div>
    <!-- <i class="el-icon-picture-outline"></i> -->
  </div>
</template>

<script>
import api from "@/apis/medal";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: "notice",
  data() {
    return {
      uploadUrl: "",
      options: [
        {
          value: 1,
          label: "部门"
        },
        {
          value: 2,
          label: "个人"
        }
      ],
      fileListCover: [], //上传图片

      form: {
        newsType: "荣光",
        title: "", //标题
        type: "", //勋章类型
        awards: "",
        fileId: "", //上传文件
        text: "", //正文
        link: "", //链接
        remark: "", //摘要
        pushCoverImageId: "", //图片id
        fileName: "", //附件名称
        awardsIds: "" // 获奖id
      },
      fileList: [],
      file: "",
      uploadType: "",
      fileUpload: {
        //附件上传
        file: null
      },
      isImageAndVideo: null,
      editorOption: {
        // 这里可以设置一些 Quill.js 的配置项
        placeholder: "请输入正文",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], //加粗，斜体，下划线，删除线
              ["blockquote", "code-block"], //引用，代码块
              [{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ list: "ordered" }, { list: "bullet" }], //列表
              [{ script: "sub" }, { script: "super" }], // 上下标
              [{ indent: "-1" }, { indent: "+1" }], // 缩进
              [{ direction: "rtl" }], // 文本方向

              [{ size: ["small", false, "large", "huge"] }], // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题

              [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
              [{ font: [] }], //字体
              [{ align: [] }], //对齐方式
              ["clean"], //清除字体样式
              ["image", "video"] //上传图片、上传视频
            ],

            handlers: {
              video: val => {
                // 覆盖默认的上传视频
                if (val) {
                  this.isImageAndVideo = 1;
                  // this.uploadType = "video/*";
                  document.querySelector(".avatar-uploader1 input").click();
                }else {
                  // this.quill.format("video", false);
                }
              },
              image: value => {
                if (value) {
                  // this.uploadType = "image/*";
                  this.isImageAndVideo = 2;
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  // this.quill.format("image", false);
                }
              }
            }
          }
        }
      }
    };
  },
  created() {
    this.uploadUrl = api.uploadUrl;
  },
  mounted() {
    //编辑带过来的信息
    if (JSON.parse(localStorage.getItem("newsInfo"))) {
      this.form = JSON.parse(localStorage.getItem("newsInfo"));
      this.fileListCover = [
        {
          url: `${this.uploadUrl}/file/view/` + this.form.pushCoverImageId
        }
      ];
      this.fileList = [
        {
          url: `${this.uploadUrl}/file/view/` + this.form.fileId,
          name: this.form.fileName
        }
      ];
    }
    // 获取表单
    let newsNoticeInfo = JSON.parse(sessionStorage.getItem("newsNoticeInfo"));
    if (newsNoticeInfo) {
      this.form = newsNoticeInfo;
      if (this.form.pushCoverImageId) {
        this.fileListCover = [
          {
            url: `${this.uploadUrl}/file/view/` + this.form.pushCoverImageId
          }
        ];
      }
      if (this.form.fileId) {
        this.fileList = [
          {
            url: `${this.uploadUrl}/file/view/` + this.form.fileId,
            name: this.form.fileName
          }
        ];
      }
    }
    sessionStorage.removeItem("newsNoticeInfo");
    // 获奖人
    if (JSON.parse(localStorage.getItem("awards"))) {
      this.form.awards = JSON.parse(localStorage.getItem("awards"))
        .map(item => {
          return item.nickname;
        })
        .toString();
      this.form.awardsIds = JSON.parse(localStorage.getItem("awards"))
        .map(item => {
          return item.oid;
        })
        .toString();
    }
    localStorage.removeItem("awards");
  },
  methods: {
    //消息提示
    uploadError() {
      this.$message.error("插入失败");
    },
    //上传成功
    uploadSuccess(res) {
      // 首先获取富文本编辑器的实例
      let quill = this.$refs.myQuillEditor.quill;
      // 上传成功所执行
      if (res.code == 200 && res.data !== null) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片res为服务器返回的数据
        if (this.isImageAndVideo === 1) {
          quill.insertEmbed(
            length,
            "video",
            this.uploadUrl + res.data.iconPath
          );
        } else {
          quill.insertEmbed(
            length,
            "image",
            this.uploadUrl + res.data.iconPath
          );
        }

        // 光标移动至文本末端
        quill.setSelection(length + 1);
      } else {
        this.$message.error("插入失败");
      }
    },
    //获奖人
    awardsInfo() {
      sessionStorage.setItem("newsNoticeInfo", JSON.stringify(this.form));
      this.$router.push("/mobile/medal/awards");
    },
    //附件 上传成功
    onSuccessFile(response) {
      this.form.fileId = response.data.id;
      this.form.fileName = response.data.name;
    },
    // 附件 删除
    handleRemove() {
      this.form.fileId = "";
      this.form.fileName = "";
      this.fileList = [];
    },

    //附件 超出个数限制时的钩子
    handleExceed() {
      this.$toast("只能上传一个文件,请删除原文件重新上传");
    },
    //图片上传成功
    onSuccessCover(response) {
      this.form.pushCoverImageId = response.data.id;
    },
    //图片删除
    onRemoveCover() {
      this.fileListCover = [];
      this.form.pushCoverImageId = "";
    },
    //图片超出个数限制时的钩子
    handleExceedImg() {
      this.$toast("只能上传一张图片,请删除原图片重新上传");
    },
    // 取消
    cancel() {
      this.$router.replace("/mobile/medal/newsNotice");
    },
    //确认提交
    submit(num) {
      if (!this.form.title) {
        return this.$toast("请输入标题");
      }
      if (!this.form.type) {
        return this.$toast("请选择勋章类型");
      }
      if (!this.form.awards) {
        return this.$toast("请选择获奖人/部门");
      }
      if (!this.form.text) {
        return this.$toast("请输入正文");
      }
      if (!this.form.fileId) {
        return this.$toast("请选择上传文件");
      }
      if (!this.form.remark) {
        return this.$toast("请输入摘要");
      }

      if (!this.form.pushCoverImageId) {
        return this.$toast("请选择封面");
      }
      const title=num==1?'暂存':this.form.id ? "编辑" : "新增"
      api.addOrUpdateNew(this.form).then(res => {
        if (res.code === 200) {
          this.$toast(`${title}成功`);
          this.$router.replace("/mobile/medal/newsNotice");
        }
      });
    }
  },
  beforeDestroy() {
    localStorage.removeItem("newsInfo");
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #noticeWrapper {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #noticeWrapper {
    width: 276px * $zoom;
  }
}
#noticeWrapper {
  padding: 0 36px 10px 36px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  // background-color:#F7F9FA;
  .noticeContent {
    flex: 1;
    overflow-y: auto;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .header {
      ::v-deep(.van-tab) {
        font-size: 29px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #969b9e;
      }
      ::v-deep(.van-tab--active) {
        font-size: 36px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #282b32;
      }
      ::v-deep(.van-tabs__line) {
        border-radius: 0 !important;
      }
    }
    .container_item {
      .title {
        display: flex;
        align-items: flex-end;
        padding: 40px 0 20px 0;
        .title_txt {
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #282b32;
          line-height: 44px;
        }
      }
      .hidden {
        ::v-deep .el-upload {
          display: none;
        }
      }
      ::v-deep .el-input {
        .el-input__inner {
          width: 100%;
          height: 72px;
          background: #f7f9fa;
          border: none;
          padding: 0 12px;
          border-radius: 8px;
          font-size: 29px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 72px;
          &::placeholder {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            // color: #969B9E;
            color: #606266;
            line-height: 72px;
          }
        }
      }
      ::v-deep .el-upload--picture-card{
        width: 200px;
        height: 124px;
        line-height: 124px;
      }
      ::v-deep .el-upload-list--picture-card .el-upload-list__item{
        width: 200px;
        height: 124px;
      }
      ::v-deep .el-icon-plus::before{
        content:'\e75e';
      }
      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 45%;
      }
      .date_picker_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      ::v-deep .el-input__icon {
        line-height: 72px;
        &::before {
          font-size: 32px;
        }
      }
    }
  }
  .container_itemAdd {
    .title {
      // display: flex;
      // align-items: flex-end;
      flex: 1;
      padding: 40px 0 20px 0;
      .title_txt {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #282b32;
        line-height: 44px;
      }
    }
    .hidden {
      ::v-deep .el-upload {
        display: none;
      }
    }
    .uploadImg {
      padding: 40px 0 20px 0;
    }
  }
  .footerBtn {
    height: 123px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    ::v-deep(.van-button--small) {
      width: 30%;
      height: 83px;
      border-radius: 16px;
      font-size: 27px;
      border: 0;
    }
  }
  ::v-deep .quill-editor {
    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
      content: "14px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
      content: "10px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
      content: "18px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
      content: "32px";
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
      content: "文本";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
      content: "标题1";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
      content: "标题2";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
      content: "标题3";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
      content: "标题4";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
      content: "标题5";
    }
    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
      content: "标题6";
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
      content: "标准字体";
    }
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
      content: "衬线字体";
    }
    .ql-snow
      .ql-picker.ql-font
      .ql-picker-label[data-value="monospace"]::before,
    .ql-snow
      .ql-picker.ql-font
      .ql-picker-item[data-value="monospace"]::before {
      content: "等宽字体";
    }
    // .ql-editor.ql-blank::before {
    //   content: "请输入正文";
    // }
  }
}
</style>
